import React, { useState } from 'react'

// components
import Result from './Result'
import Status from './Status'

const JobCreation = ({status, userInput}) => {

  async function sendEmail(form, resetForm, cb) {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/census/job-info`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          form,
          userInput
        })
      }
    );
    
    cb();
  }

  return (
    <div style={{backgroundColor: '#e8e8e8', padding: 10, marginTop: 30}}>
      <Status qualifiedStatus={status} />
      <Result
        isQualified={status === 'success'}
        address="aacascas"
        qualifiedStatus={status}
        sendEmail={sendEmail}
        jobs={userInput.jobs}
      />
    </div>
  );
}

export default JobCreation;
